"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PitchGeometryFactory = void 0;
const tslib_1 = require("tslib");
const homography_1 = require("../homography");
const vector_1 = require("./../vector");
const Project = tslib_1.__importStar(require("./coordinate.projection"));
const geometry_3d_1 = require("./geometry.3d");
const GeoUtil = tslib_1.__importStar(require("./geometry.util"));
const ALIGNMENT_SIZE = 1;
class PitchGeometryFactory {
    create(ctx) {
        return PitchGeometryFactory.create(ctx);
    }
    static create(ctx) {
        var creationContext = {
            planeCenter_MRW: null,
            planeNormal_MRW: null,
            planeAxis_MP: null,
            planeOrigin_MRW: null,
            focalLength: -1,
            calibration: null,
            homography: null,
            ctx,
            createdBy: geometry_3d_1.Geometry3DCreationMethod.PITCH,
        };
        if (ctx.calibration) {
            creationContext.focalLength = ctx.calibration.focal;
            creationContext.calibration = ctx.calibration;
        }
        else {
            creationContext.focalLength = ctx.focalLength || GeoUtil.calculateFocalLength(ctx.resolution, ctx.viewAngle);
        }
        creationContext.planeOrigin_MRW = creationContext.planeCenter_MRW = new vector_1.Vector(0, 0, ctx.distance * -1);
        creationContext.planeNormal_MRW = new vector_1.Vector(0, Math.sin(ctx.pitch), Math.cos(ctx.pitch));
        creationContext.planeAxis_MP = { x: null, y: null };
        creationContext.planeAxis_MP.x = new vector_1.Vector(-1, 0, 0);
        creationContext.planeAxis_MP.y = creationContext.planeNormal_MRW.cross(creationContext.planeAxis_MP.x);
        creationContext.homography = PitchGeometryFactory.calculateHomography(creationContext, ctx.resolution);
        return new geometry_3d_1.Geometry3D(creationContext);
    }
    static calculateHomography(ctx, resolution) {
        var alignmentGrid_MP = [
            [0, 0],
            [ALIGNMENT_SIZE, 0],
            [ALIGNMENT_SIZE, ALIGNMENT_SIZE],
            [0, ALIGNMENT_SIZE],
        ].map(vector_1.Vector.create);
        var ProjectMeasureToCalibrated = Project.MeasureToCalibrated.bind(null, ctx.focalLength, ctx.planeOrigin_MRW, ctx.planeAxis_MP, resolution);
        var ProjectCalibratedToImage = Project.CalibratedToImage.bind(null, resolution);
        var alignmentGrid_CI = alignmentGrid_MP.map(ProjectMeasureToCalibrated);
        var alignmentGrid_IP = alignmentGrid_CI.map(ProjectCalibratedToImage);
        return homography_1.Homography.create(alignmentGrid_IP, alignmentGrid_MP);
    }
}
exports.PitchGeometryFactory = PitchGeometryFactory;
//# sourceMappingURL=geometry.factory.pitch.js.map